import styled from 'styled-components';

const StyledPasswordSettingsLoader = styled.section`
   display: flex;
   gap: 0.5em;
`;
StyledPasswordSettingsLoader.displayName = 'StyledPasswordSettingsLoader';

export { StyledPasswordSettingsLoader };
